'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreFilledCards = exports.getCardPickerHeaderText = exports.getAddCardText = exports.getAnnualFeeLabel = exports.getLabels = exports.getCards = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _dtmLinkAppend = require('acq-components/lib/utils/DTM/dtmLinkAppend');

var _componentHelpers = require('../../utils/component-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DTM_AddCard = 'AddCard';
var DTM_RemoveCard = 'RemoveCard';

var updateDtmObject = function updateDtmObject(dtm, dtmProductName) {
  if (dtm) {
    return (0, _extends3.default)({}, dtm, {
      eventAsset: (0, _componentHelpers.getEventAsset)(dtm.eventAsset, dtmProductName)
    });
  } else {
    return {};
  }
};

var updateLinkUrl = function updateLinkUrl(url, dtmProduct, linkObj, pageDtmInfo) {
  var navTypeRaw = linkObj && linkObj.dtm ? linkObj.dtm.eventAction : '';
  var navType = [_dtmConsts.DTM_CONSTS.defaultNavType, _dtmConsts.DTM_CONSTS.intLinkNavType].includes(navTypeRaw) ? navTypeRaw : _dtmConsts.DTM_CONSTS.defaultNavType;

  return url ? (0, _dtmLinkAppend.appendLinkNav)(url, navType, pageDtmInfo.linkNavBase, pageDtmInfo.pageName, dtmProduct, (0, _lodash2.default)(linkObj, 'dtm.eventAsset')) : url;
};
var updateCardFeatures = function updateCardFeatures(cardFeatures, dtmProduct, pageDtmInfo) {
  return (0, _extends3.default)({}, cardFeatures, {
    content: (cardFeatures && Array.isArray(cardFeatures.content) ? cardFeatures.content : []).map(function (contentItem) {
      return (0, _extends3.default)({}, contentItem, {
        links: (contentItem.links || []).map(function (link) {
          return (0, _extends3.default)({}, link, {
            url: updateLinkUrl(link.url, dtmProduct, link, pageDtmInfo)
          });
        })
      });
    })
  });
};

var getCards = exports.getCards = (0, _reselect.createSelector)([function (state) {
  return (0, _lodash2.default)(state.intlPage, 'cards') || [];
}, function (state) {
  return (0, _lodash2.default)(state.intlPage, 'dtm') || {};
}], function (cards, pageDtmInfo) {
  return cards.map(function (card) {
    return (0, _extends3.default)({}, card, {
      cardArtUrl: (0, _lodash2.default)(card, 'assets[0].url'),
      cardArtAlt: (0, _lodash2.default)(card, 'assets[0].alt'),
      links: (card.links || []).map(function (link) {
        return (0, _extends3.default)({}, link, {
          dtm: (0, _extends3.default)({}, updateDtmObject(link.dtm, card.dtmProductName)),
          url: updateLinkUrl(link.url, card.dtmProductName, link, pageDtmInfo)
        });
      }),
      cardFeatures: updateCardFeatures(card.cardFeatures, card.dtmProductName, pageDtmInfo),
      removeCardDtm: (0, _componentHelpers.createClickDtmObj)((0, _componentHelpers.getEventAsset)(DTM_RemoveCard, card.dtmProductName)),
      cardPickerSelectDtm: (0, _componentHelpers.createClickDtmObj)((0, _componentHelpers.getEventAsset)(DTM_AddCard, card.dtmProductName)),
      ctaKey: pageDtmInfo.linkNavBase.indexOf('mx-acq-gcp-corporate') === 0 ? 'learnMore' : null
    });
  });
});

var nonSectionLabels = ['addAnotherCard', 'cardPickerHeaderText'];
var byNonSectionLabel = function byNonSectionLabel(item) {
  return item && !nonSectionLabels.includes(item.identifier);
};
var getLabels = exports.getLabels = function getLabels(state) {
  var labels = (0, _lodash2.default)(state.intlPage, 'page.labels') || [];
  return labels.filter(byNonSectionLabel);
};

var getAnnualFeeLabel = exports.getAnnualFeeLabel = (0, _reselect.createSelector)([function (state) {
  return (0, _lodash2.default)(state.intlPage, 'page.cardTiles.labels') || [];
}, function (state) {
  return (0, _lodash2.default)(state.intlPage, 'page.labels') || [];
}], function (cardTilesLabels, pageLabels) {
  return ([].concat((0, _toConsumableArray3.default)(cardTilesLabels), (0, _toConsumableArray3.default)(pageLabels)).find(function (label) {
    return label.identifier === 'annualFee';
  }) || {}).text || '';
});

var getCardPicker = function getCardPicker(state) {
  return (0, _lodash2.default)(state, 'intlPage.page.cardPicker') || {};
};
var getCardTiles = function getCardTiles(state) {
  return (0, _lodash2.default)(state, 'intlPage.page.cardTiles') || {};
};
var getPageData = function getPageData(state) {
  return (0, _lodash2.default)(state, 'intlPage.page') || {};
};

var getAddCardText = exports.getAddCardText = (0, _reselect.createSelector)(getCardTiles, function (cardTiles) {
  return cardTiles.header;
});

var getCardPickerHeaderText = exports.getCardPickerHeaderText = (0, _reselect.createSelector)(getCardPicker, function (cardPicker) {
  return cardPicker.header;
});

var getPreFilledCards = exports.getPreFilledCards = (0, _reselect.createSelector)(getPageData, function (pageData) {
  return pageData.preFilledCards || [];
});